import * as Yup from 'yup'

const errorMessage = 'Please fill in the required field'

export const ManageTasklistFormValidator = Yup.object().shape({
  description: Yup.string().required(errorMessage),
  name: Yup.string().required(errorMessage).max(52),
})
